var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderDelivered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#01b762"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336",
    transform: "translate(-0.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bx-check",
    d: "M7.514,11.206,5.96,9.652l-.667.667L7.514,12.54l4.58-4.58-.667-.667Z",
    transform: "translate(67.438 10.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-car",
    d: "M30.408,13.315,28.338,7.1A4.532,4.532,0,0,0,24.033,4h-13.8A4.532,4.532,0,0,0,5.929,7.1l-2.07,6.211A3.027,3.027,0,0,0,2,16.107v7.567a3.014,3.014,0,0,0,1.513,2.607v3.446A1.513,1.513,0,0,0,5.027,31.24H6.54a1.513,1.513,0,0,0,1.513-1.513V26.7h18.16v3.027a1.513,1.513,0,0,0,1.513,1.513H29.24a1.513,1.513,0,0,0,1.513-1.513V26.281a3.012,3.012,0,0,0,1.513-2.607V16.107a3.027,3.027,0,0,0-1.858-2.792ZM10.234,7.027h13.8a1.51,1.51,0,0,1,1.436,1.035l1.674,5.018H7.126L8.8,8.062A1.513,1.513,0,0,1,10.234,7.027ZM7.3,22.16a2.271,2.271,0,1,1,2.272-2.27A2.271,2.271,0,0,1,7.3,22.16Zm19.673,0a2.271,2.271,0,1,1,2.272-2.27A2.271,2.271,0,0,1,26.97,22.16Z",
    transform: "translate(43.865 15.88)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelivered);
export default __webpack_public_path__ + "static/media/order-delivered.f93d582e2f80d9daaf768433a90237ea.svg";
export { ForwardRef as ReactComponent };